import React from 'react';
import Skeleton from '@mui/material/Skeleton';

const SkeletonEmpty = ({settings}) => {
  const customStyle = {
    //backgroundColor: '#FAC3C6',
    //overflow: 'hidden',
    //borderRadius: '4px', // Beispiel für weitere benutzerdefinierte Stile
    //opacity: '0.1',
  };

  return (
    <div className="ips-bootstrap content-element">

       <div className="row py-2 justify-content-center">
        <div className="col-12 text-center">
          <strong>{settings.emptycarttext}</strong>
        </div>
      </div>
  
  </div>
  );
};

export default SkeletonEmpty;